import axios from "axios";
import { CONTENT_TEMPLATE_TYPE } from "@/helpers/constants";

export default {
    getInvoiceTemplate: async(contentTemplateChannel, account_id) => {
        const { data } = await axios.get(`/content_template/${CONTENT_TEMPLATE_TYPE.INVOICE}/${contentTemplateChannel}/${account_id}`)
        return data
    },
    saveInvoiceTemplate: async(template) => {
        const { data } = await axios.post(`/content_template/${CONTENT_TEMPLATE_TYPE.INVOICE}/${template.channel}/${template.account_id}`, { template: template })
        return data
    }
}